import { getApiBaseUrl } from "../config/runtimeConfig";

export interface PublicPasswordCheckResponse {
  token: string;
  expires_at: string;
}

const submitPublicPasswordCheck = async (
  path: string,
  password: string,
): Promise<PublicPasswordCheckResponse> => {
  const response = await fetch(`${getApiBaseUrl()}${path}`, {
    method: "POST",
    mode: "cors",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ password }),
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    const err = new Error(
      body?.detail || `Password check failed (${response.status})`,
    );
    (err as Error & { status?: number }).status = response.status;
    (err as Error & { retryAfter?: number }).retryAfter = body?.retry_after;
    throw err;
  }
  return (await response.json()) as PublicPasswordCheckResponse;
};

export const publicDocumentPasswordCheck = (
  documentId: string,
  password: string,
): Promise<PublicPasswordCheckResponse> =>
  submitPublicPasswordCheck(
    `/api/public/documents/${encodeURIComponent(documentId)}/password-check`,
    password,
  );
